// iter45ap commit 3 — checkout create payload builder.
//
// Single source of truth for the (package_id, project_id) pair sent
// to /payments/paypal/create-order and /payments/paddle/create-transaction.
// Consumed from PurchaseModal.jsx at both provider sites; locked by
// the contract test at src/components/__tests__/purchaseCheckout.test.js.
//
// Discriminator: `pkg.id === "single_report"`. NOT `pkg.kind === "single"`
// — every entry in the frontend PACKAGES table has `kind: "credits"`,
// which is why the two inline `pkg.kind === "single"` guards at
// PurchaseModal.jsx:319 and :596 have been dead since e1ce60d and sent
// null for every buyer.
//
// The backend guard in commit 4 (`_fulfill`) will consume `package_id`
// verbatim from the txn row — the two discriminators must match. If
// one moves, both move.

/**
 * Build the payload for /payments/{provider}/create-{order|transaction}.
 *
 * @param {object}   args
 * @param {object}   args.pkg         Package row from the PACKAGES table
 *                                    (must have .id).
 * @param {?string}  args.projectId   Project id the buyer is trying to
 *                                    unlock, or null/undefined if the
 *                                    checkout was opened from the
 *                                    pricing page.
 * @returns {{package_id: string, project_id: ?string}}
 *          project_id is non-null ONLY for single_report opened from a
 *          project paywall — bundle top-ups never carry a project_id
 *          even if the buyer opened checkout from a project view (so
 *          the backend's auto-unlock can't misfire on a bundle).
 */
export function buildCheckoutPayload({ pkg, projectId }) {
  const isSingleReport = pkg && pkg.id === "single_report";
  const effectiveProjectId =
    isSingleReport && projectId && projectId !== "" ? projectId : null;
  return {
    package_id: pkg && pkg.id,
    project_id: effectiveProjectId,
  };
}
